<section id="bereich_wechseln_card" class="d-flex flex-column">
  <h3 class="now-heading">Nichts Passendes gefunden?</h3>
  <div
    class="now-copytext now-body-large now-standard-block-text"
    [innerHTML]="cardText$ | async"
  ></div>
  <div class="buttonrow">
    <button class="now-btn now-btn-secondary" (click)="setBildungsbereich()">Auswahl ändern</button>
  </div>
</section>

<now-wbsuche-lib-modal-popup
  #bildungsbereichWechselnModal
  modalId="modal-bildungsbereich-aendern"
  modalTitle="Weiterbildungsziel ändern"
  primaryButtonText="Auswahl ändern"
  secondaryButtonText="Abbrechen"
  [primaryBeforeSecondary]="false"
  ariaLabel="Hinweis zum wechsel des Bildungsbereichs"
>
  Wenn Sie Ihr Weiterbildungsziel ändern, werden alle Filter außer „Ort“ und „Umkreis“
  zurückgesetzt. Ihre Sucheingabe bleibt bestehen. Möchten Sie fortfahren?
</now-wbsuche-lib-modal-popup>
